import { store } from '@/iti-core-vue/store';
import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
    namespaced: true,
    name: 'PublicLayout',
    store,
    dynamic: true,
  })
  class PublicLayout extends VuexModule {

    public webTab: string = '/';
    
    @Mutation
    public setWebTab(newWebTab: string) {
        this.webTab = newWebTab;
    }


}  

export default getModule(PublicLayout);